module.exports = __webpack_public_path__ + "assets/img/zh5.6d50256a.png";